import { createContext } from 'react'

const StatisticsContext = createContext(undefined as any)

export default StatisticsContext
